(function () {
  'use strict';

  // =============================================================================
  // プレオープンチケット (2609ssk) 購入制限 — カートページ・カートドロワー (第 2 層)
  // =============================================================================
  // 3 層の守り: 商品ページ (preopen-limit.js) → カートガード (これ) → API の over_limit 判定。
  // 定数・文言・allowance キャッシュ・カート集計は preopen-shared.js (window.KBPreopen)。
  //
  // パイプライン: read (cart + allowance) → deriveVerdict(summary, allowance) → apply (checkout ボタン + メッセージ)
  //   - カート内のプレオープン枚数が 上限超過 / 複数枠 / (ログイン時) 購入済みとの合算超過 / 購入済みと別枠
  //     なら checkout ボタンを無効化して案内する。範囲内に戻れば自分が無効化したものだけ戻す
  //   - API エラー時は静的ルール (上限・単一枠) だけで判定 (fail-open)。サーバー強制ではない
  //
  // 依存する Horizon の挙動:
  //   - cart-items-component が追加・数量変更・削除のたびに cart:update を document までバブルさせる
  //     (event.detail.resource がカート JSON のときは再取得しない)
  //   - ドロワー / カートセクションはサーバー HTML で morph され、disabled やメッセージが消える →
  //     MutationObserver で直前の判定を同期的に戻してから、あらためて再評価する
  //   - checkout ボタン = snippets/cart-summary.liquid の button#checkout[name="checkout"] (親 .cart__ctas)

  var K = window.KBPreopen;
  if (!K) return;

  var cfgEl = document.getElementById('preopen-cart-guard-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var SEL = K.SELECTORS;
  var EV = K.EVENTS;
  var MSG = K.MESSAGES;
  var API_BASE = (cfg.apiBase || '').replace(/\/+$/, '');
  var MSG_CLASS = 'preopen-cart-guard__msg';
  var BLOCKED_ATTR = 'data-preopen-blocked';

  // 状態
  var state = {
    lastVerdict: null,                       // 直前に適用した判定 (morph 後に同期再適用する)
    sawPreopen: !!cfg.hasPreopenInCart,      // このページでプレオープン明細を見たか (visibilitychange の再評価条件)
    evaluating: false,                       // 評価の直列化
    queued: false,
    queuedCart: null,
  };

  // ---------------------------------------------------------------------------
  // 判定 (純粋)。null なら checkout 可
  // ---------------------------------------------------------------------------
  function deriveVerdict(summary, allowance) {
    if (summary.persons === 0) return null;
    var max = allowance ? allowance.max : K.MAX;
    if (summary.persons > max) return MSG.cartOverMax(max, summary.persons);
    if (summary.skus.length > 1) return MSG.cartMixedSlots();
    if (allowance) {
      if (allowance.remaining <= 0) return MSG.limitReachedPurchased(max);
      if (summary.persons > allowance.remaining) return MSG.cartOverAllowance(allowance.purchased, max, allowance.remaining);
      if (allowance.slot_sku && summary.skus[0] !== allowance.slot_sku) {
        return MSG.cartSlotMismatch(allowance.slot_label || allowance.slot_sku);
      }
    }
    return null;
  }

  // ---------------------------------------------------------------------------
  // 適用
  // ---------------------------------------------------------------------------
  function ctaWraps() {
    var out = [];
    var buttons = document.querySelectorAll(SEL.checkoutButtons);
    for (var i = 0; i < buttons.length; i++) {
      var wrap = buttons[i].closest(SEL.checkoutWrap) || buttons[i].parentElement;
      if (wrap && out.indexOf(wrap) === -1) out.push(wrap);
    }
    return out;
  }

  function apply(verdict) {
    state.lastVerdict = verdict;
    var wraps = ctaWraps();
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var buttons = wrap.querySelectorAll(SEL.checkoutButtons);
      var msg = wrap.querySelector('.' + MSG_CLASS);
      var j;
      if (verdict) {
        wrap.setAttribute(BLOCKED_ATTR, '1');
        for (j = 0; j < buttons.length; j++) {
          buttons[j].disabled = true;
          buttons[j].setAttribute(BLOCKED_ATTR, '1');
        }
        if (!msg) {
          msg = document.createElement('p');
          msg.className = MSG_CLASS;
          msg.setAttribute('role', 'alert');
          wrap.insertBefore(msg, wrap.firstChild);
        }
        // 文言は 1 件、または複数行 (配列)。text 内の \n も改行にする
        msg.textContent = '';
        var list = Object.prototype.toString.call(verdict) === '[object Array]' ? verdict : [verdict];
        for (var n = 0; n < list.length; n++) {
          var one = list[n];
          var lineEl = document.createElement('span');
          lineEl.className = 'preopen-cart-guard__line' + (one.plain ? ' preopen-cart-guard__line--plain' : '');
          msg.appendChild(lineEl);
          var parts = String(one.text == null ? '' : one.text).split('\n');
          for (var k = 0; k < parts.length; k++) {
            if (k > 0) lineEl.appendChild(document.createElement('br'));
            if (parts[k]) lineEl.appendChild(document.createTextNode(parts[k]));
          }
          if (one.link && one.href) {
            if (one.br) lineEl.appendChild(document.createElement('br'));
            var a = document.createElement('a');
            a.href = one.href;
            a.textContent = one.link;
            lineEl.appendChild(a);
            if (one.after) lineEl.appendChild(document.createTextNode(one.after));
          }
        }
      } else {
        wrap.removeAttribute(BLOCKED_ATTR);
        for (j = 0; j < buttons.length; j++) {
          if (buttons[j].hasAttribute(BLOCKED_ATTR)) {
            buttons[j].removeAttribute(BLOCKED_ATTR);
            buttons[j].disabled = false; // 自分で無効化したものだけ戻す (空カートの disabled は触らない)
          }
        }
        if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
      }
    }
  }

  // ---------------------------------------------------------------------------
  // パイプライン (直列化。実行中に再要求が来たら終了後にもう 1 回)
  // ---------------------------------------------------------------------------
  function evaluateWith(cart) {
    var summary = K.summarizeCart(cart);
    if (summary.persons === 0) {
      apply(null);
      return Promise.resolve();
    }
    state.sawPreopen = true;
    return K.fetchAllowance({ apiBase: API_BASE, customerId: cfg.customerId, customerHmac: cfg.customerHmac })
      .then(function (allowance) { apply(deriveVerdict(summary, allowance)); });
  }

  function evaluate(cartJson) {
    if (state.evaluating) {
      state.queued = true;
      if (cartJson) state.queuedCart = cartJson;
      return;
    }
    state.evaluating = true;
    (cartJson ? Promise.resolve(cartJson) : K.readCart())
      .then(evaluateWith)
      .catch(function () { /* fail-open */ })
      .then(function () {
        state.evaluating = false;
        if (state.queued) {
          state.queued = false;
          var c = state.queuedCart;
          state.queuedCart = null;
          evaluate(c);
        }
      });
  }

  var timer = null;
  var pendingCart = null;
  function schedule(delay, cartJson) {
    if (cartJson) pendingCart = cartJson; // カート JSON 付きの要求を、後から来た JSON なしの要求で潰さない
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      var c = pendingCart;
      pendingCart = null;
      evaluate(c);
    }, delay);
  }

  // ---------------------------------------------------------------------------
  // Horizon のイベントに追従
  // ---------------------------------------------------------------------------
  document.addEventListener(EV.cartUpdate, function (e) {
    K.clearAllowanceCache();
    schedule(100, K.cartFromEvent(e));
  });

  // 自分が挿したメッセージ以外の変化か
  function isForeignMutation(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var t = m.target;
      if (t && t.closest && t.closest('.' + MSG_CLASS)) continue;
      var own = true;
      var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (!(n instanceof Element) || !n.classList.contains(MSG_CLASS)) { own = false; break; }
      }
      if (!nodes.length || !own) return true;
    }
    return false;
  }

  function observe() {
    if (typeof MutationObserver === 'undefined') return;
    var targets = document.querySelectorAll(SEL.cartComponents);
    if (!targets.length) return;
    var mo = new MutationObserver(function (mutations) {
      if (!isForeignMutation(mutations)) return;
      if (state.lastVerdict) apply(state.lastVerdict); // morph で消えた disabled / メッセージを即戻す
      schedule(250);                                    // その上で再評価
    });
    for (var i = 0; i < targets.length; i++) mo.observe(targets[i], { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      K.clearAllowanceCache();
      evaluate();
    }
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && state.sawPreopen) evaluate();
  });

  // ---------------------------------------------------------------------------
  // 起動
  // ---------------------------------------------------------------------------
  function boot() {
    try {
      observe();
      if (cfg.hasPreopenInCart) evaluate(); // Liquid でプレオープン明細が無いと分かるページでは初回 /cart.js を省く
    } catch (e) {
      console.warn('[preopen-cart-guard] init failed:', e && e.message);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
